import {UnorderedList} from '@chakra-ui/react';

export default function ChakraOrderedList({children, ...rest}) {
    return <UnorderedList {...rest}>{children}</UnorderedList>;
}
